import React from 'react';
import TemplateForm from './TemplateForm';
import MapList from './Map/MapList';
import { modifyTemplate } from '../../api';
import { connect } from 'react-redux';
import { onModificationSuccess } from './util';
import { UserPermissionContainer } from '@its/components/lib/Container components/UserContainer/UserPermissionContainer';
import {
  developer,
  admin,
} from '@its/components/lib/Container components/UserContainer/roles';

const onSubmit = (template, values) => Object.assign({}, template, values);

const mapStateToProps = (state) => (
  {
    name: 'modifyTemplate',
    request: modifyTemplate(state.app.templates.detail.id),
    initialValues: state.app.templates.detail,
    onSubmit: onSubmit.bind(null, state.app.templates.detail),
    onSuccess: onModificationSuccess,
    appBar: {
      title: 'TEMPLATE',
      navigateBack: true,
    },
  }
);

const ModificationForm = connect(
  mapStateToProps
)(TemplateForm);

export default class extends React.Component {

  render() {
    return (
      <UserPermissionContainer
        allowedRoles={[developer, admin]}
        showError
      >
        <div>
          <ModificationForm />
          <MapList />
        </div>
      </UserPermissionContainer>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/routes/Template/Template.js
 **/